export const stats = [
  { value: '+60', label: 'Units Ready' },
  { value: '+2,000', label: 'Teachers Satisfied' },
  { value: '4,200+', label: 'Hours Saved' },
  { value: '99%', label: 'Would Recommend It' },
]

export const differenceStats = [
  { value: '+70', label: 'Ready-to-Teach Units (A1 to C1)' },
  { value: '6', label: 'Complete Digital Volumes' },
  { value: '100%', label: 'Instantly Downloadable' },
]

export const beforeItems = [
  'Hours planning every single ESL class',
  'Repetitive and dry grammar exercises',
  'No clear connection to the real world',
  'Not knowing how to grade or assess properly',
  'Unmotivated students who "hate English"',
]

export const afterItems = [
  "5-minute review and you're set",
  'Visual and engaging language projects',
  'Real-world applications integrated',
  'Quizzes, exams, and rubrics ready',
  'Students speaking with absolute confidence',
]

export const recognizeItems = [
  {
    emoji: '😰',
    text: 'Arriving to class without knowing exactly how to explain a complex tense',
  },
  {
    emoji: '⏱️',
    text: 'Spending your entire Sunday planning what should take minutes',
  },
  {
    emoji: '🤷',
    text: 'Struggling to find worksheets that are actually high-quality and visual',
  },
  {
    emoji: '📋',
    text: 'No clear assessments or rubrics aligned with the school year',
  },
  {
    emoji: '😴',
    text: "Students falling behind because the material isn't connected to their level",
  },
  { emoji: '🌙', text: 'Still not ready for Monday by Sunday night' },
]

export const packItems = [
  {
    emoji: '📚',
    title: '5 Level-Based Volumes (A1–C1)',
    text: 'A full curriculum from absolute beginner to advanced academic English',
  },
  {
    emoji: '🏛️',
    title: 'Volume 6: The Master Plan',
    text: "The teacher's OS: rubrics, calendars, placement tests, and tracking sheets",
  },
  {
    emoji: '✏️',
    title: 'Step-by-Step Lesson Scripts',
    text: 'Teacher prompts that tell you exactly how to lead the class in seconds',
  },
  {
    emoji: '📐',
    title: 'Visual Grammar & Worksheets',
    text: 'High-quality graphics that make complex rules simple to understand',
  },
  {
    emoji: '📊',
    title: 'Assessments & Final Exams',
    text: 'Complete assessment tools for every single level (A1 to C1)',
  },
  {
    emoji: '🔑',
    title: 'Full Answer Keys',
    text: 'Grading is finally instant, accurate, and stress-free',
  },
]

export const samplePages = [
  {
    level: 'A1',
    caption: 'Level A1',
    title: 'Unit 03 · Create Your English Profile',
    text: 'Guided personal info, pair interviews, and a quick self-check.',
    image:
      'https://cdn.magicpatterns.com/uploads/wHpKxiUgxkEnZUtnz5yUEo/Captura-de-pantalla-2026-09-24-a-las-3.18.39_p._m..webp',
  },
  {
    level: 'A2',
    caption: 'Level A2',
    title: 'A Day at Work / Study',
    text: 'Real-life profiles, comprehension questions, and a speaking mission.',
    image:
      'https://cdn.magicpatterns.com/uploads/v7jyihg4DxqZdMf9w8JA8Y/Captura-de-pantalla-2026-09-24-a-las-3.19.49_p._m..webp',
  },
  {
    level: 'B1',
    caption: 'Level B1',
    title: 'What Happened Next? · Unit 02',
    text: 'Picture storytelling with connectors and a 60-second challenge.',
    image:
      'https://cdn.magicpatterns.com/uploads/kjbauTdbcpLn8zdmTLfdyU/Captura-de-pantalla-2026-09-24-a-las-3.20.44_p._m._(1).webp',
  },
  {
    level: 'B2',
    caption: 'Level B2',
    title: 'The Future of Daily Life · Unit 06',
    text: 'Prediction language, discussion prompts, and a debate challenge.',
    image:
      'https://cdn.magicpatterns.com/uploads/vGc71iAHWtcSwxbuLMcjcA/Captura-de-pantalla-2026-09-24-a-las-3.21.37_p._m..webp',
  },
  {
    level: 'C1',
    caption: 'Level C1',
    title: 'C1 Grammar at a Glance',
    text: 'Eight advanced structures mapped visually on a single page.',
    image:
      'https://cdn.magicpatterns.com/uploads/pPuspjae3Y4YCDQdNJgijh/Captura-de-pantalla-2026-09-24-a-las-3.26.53_p._m..webp',
  },
  {
    level: 'Placement',
    caption: 'Placement Test',
    title: 'Speaking Placement Check',
    text: 'A ready-to-use rubric to place every student at the right CEFR level.',
    image:
      'https://cdn.magicpatterns.com/uploads/5B23gDGRZ7xw1GgAZcGYcT/Captura-de-pantalla-2026-09-24-a-las-3.43.13_p._m..webp',
  },
]

export const instantItems = [
  'The 6 complete digital volumes (Starter to Master Plan Series)',
  'Activities, games, and projects by CEFR level',
  'Visual lessons for every linguistic concept',
  'Teacher scripts that tell you exactly what to say',
  'Answer keys for every worksheet and exam in the system',
]

export const bonuses = [
  {
    title: 'The First 24 Hours: Day One Pack',
    was: '$19',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/a3c9b3ff-2a3c-4a55-8ccc-f7fe159867f2.jpg',
  },
  {
    title: 'The 5-Minute Warmer Bank (100 Prompts)',
    was: '$27',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/b09ec8ea-f80a-4d1f-901e-814d89c3c364.jpg',
  },
  {
    title: 'The Automated Feedback System (50 Templates)',
    was: '$36',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/4a551eb6-797e-4fd6-9f89-e1a86d11185c.jpg',
  },
  {
    title: 'The Substitute Teacher Emergency Kit',
    was: '$47',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/26edda8b-f001-4723-a209-19d68752acfd.jpg',
  },
  {
    title: 'The Hybrid Classroom Visuals (HD Assets)',
    was: '$19',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/d2bc77cf-b81f-474b-8aa5-6cfb890650fa.jpg',
  },
]

export const offerRows = [
  { label: 'ESL READY™ Pack (6 Digital Volumes)', value: '$77' },
  { label: '5 Exclusive Strategic Bonuses', value: '$148' },
]

export const testimonials = [
  {
    quote:
      'I have my Sundays back. The progression from A1 to C1 is exactly what I needed for my diverse classes.',
    name: 'Sarah M.',
    location: 'USA 🇺🇸',
  },
  {
    quote:
      'The visual grammar maps make a huge difference for my students who used to struggle with tenses.',
    name: 'Ella B.',
    location: 'UK 🇬🇧',
  },
  {
    quote:
      'The automated feedback templates alone saved my sanity this year. Worth every penny.',
    name: 'Maya K.',
    location: 'Canada 🇨🇦',
  },
  {
    quote:
      'Finally, a professional English resource that is actually organized and ready to print.',
    name: 'Sophie L.',
    location: 'Australia 🇦🇺',
  },
]

export const faqs = [
  {
    q: 'How do I receive the material?',
    a: "Instantly. After payment, you'll get a download link in your email to access all PDF and digital files.",
  },
  {
    q: "Does this work if I'm a beginner teacher?",
    a: "Yes. In fact, it's perfect for you. The scripts tell you exactly what to do so you look like a pro from day one.",
  },
  {
    q: 'What grade levels does this cover?',
    a: 'It covers all ages. The material is divided by CEFR levels (A1–C1) and includes specific contexts for kids, teens, and adults.',
  },
  {
    q: 'Are the bonuses included in the price?',
    a: 'Yes, if you purchase during the launch offer, all 5 bonuses are included for life.',
  },
  {
    q: 'Do I have to pay monthly?',
    a: 'No. This is a one-time payment for lifetime access. No hidden fees or subscriptions.',
  },
]
